import { NotRefOrderQueryParams } from "@saleor/createOrChangeNotRefContract/urls";
import {
  SplitCipOrderLineInput,
  useAddCipSplitOrderMutation
} from "@saleor/graphql";
import { FormikProps } from "formik";
import { Dispatch, SetStateAction } from "react";

import {
  saveSplitItemLineMapping,
  saveSplitItemOriginLineItemMapping
} from "../utils";

interface Props {
  orderId: string;
  formikItemDetails: FormikProps<{ lines: ChangeNotRefOrderLine[] }>;
  setSubmitState: Dispatch<SetStateAction<any>>;
  resetSubmitState: () => void;
  handleSubmitResponse: (responseData, errors) => void;
  params: NotRefOrderQueryParams;
  splitObj?: any;
  totalItemsOriginal?: number;
}

function useSaveSplitItem({
  orderId,
  formikItemDetails,
  setSubmitState,
  resetSubmitState,
  handleSubmitResponse,
  splitObj,
  params,
  totalItemsOriginal
}: Props) {
  const [addCipSplitOrderMutation] = useAddCipSplitOrderMutation();
  const getSaveSplitItemVariables = (): {
    soNo: string;
    isBom: boolean;
    originLineItems: SplitCipOrderLineInput[];
    splitLineItems: SplitCipOrderLineInput[];
    totalItems: number;
  } => {
    const isBom = formikItemDetails.values?.lines?.some(
      item => item.splitOriginal === true && item.bomFlag === true
    );
    let prev = [...(formikItemDetails.values?.lines || [])];
    if (!params?.asc) {
      prev = prev.reverse();
    }
    return {
      soNo: orderId,
      isBom: isBom || false,
      originLineItems: saveSplitItemOriginLineItemMapping(
        prev?.slice(splitObj?.index).filter(item => item.splitOriginal === true)
      ),
      splitLineItems: saveSplitItemLineMapping(
        formikItemDetails.values?.lines
          ?.slice(splitObj?.index)
          .filter(item => item.isSplit === true)
      ),
      totalItems: totalItemsOriginal
    };
  };

  async function saveSplitItem() {
    setSubmitState({ state: "processing", context: null });
    addCipSplitOrderMutation({
      variables: getSaveSplitItemVariables()
    })
      .then(({ data, errors }) => {
        const responseData = data?.addCipSplitOrderLine;
        handleSubmitResponse(responseData, errors);
      })
      .catch(() => {
        resetSubmitState();
      });
  }
  return { saveSplitItem };
}

export default useSaveSplitItem;
